import React, { useState, useEffect } from 'react';
import leftArrowIcon from './assets/left-scroll.png';
import rightArrowIcon from './assets/right-scroll.png';

const NextBestNavigator = ({ isDoc1, nextBest, currentId, changeLineItemFromMatch }) => {
  const [adjustedNextBest, setAdjustedNextBest] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    let list = [...nextBest];
    if (!list.includes(currentId)) {
      list.unshift(currentId);
    }
    setAdjustedNextBest(list);
    setCurrentIndex(list.findIndex(id => id === currentId));
  }, [nextBest, currentId]);

  const handleChange = (direction) => {
    const newIndex = currentIndex + direction;
    if (newIndex >= 0 && newIndex < adjustedNextBest.length) {
      const newId = adjustedNextBest[newIndex];
      changeLineItemFromMatch(currentId, newId);
      setCurrentIndex(newIndex);
    }
  };

  if (isDoc1 || adjustedNextBest.length <= 1) return null;

  const arrowStyle = (disabled, side) => ({
    width: 28,
    height: 'auto',
    opacity: disabled ? 0.3 : 1,
    cursor: disabled ? 'default' : 'pointer',
    pointerEvents: disabled ? 'none' : 'auto',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 9999,
    [side]: -12,
  });
  

  return (
    <>
      <img
        src={leftArrowIcon}
        alt="Previous"
        style={arrowStyle(currentIndex === 0, 'left')}
        onClick={() => currentIndex > 0 && handleChange(-1)}
      />
      <img
        src={rightArrowIcon}
        alt="Next"
        style={arrowStyle(currentIndex === adjustedNextBest.length - 1, 'right')}
        onClick={() => currentIndex < adjustedNextBest.length - 1 && handleChange(1)}
      />
    </>
  );
};

export default NextBestNavigator;
